import * as TYPES from "../constants"
import { connectRouter } from "connected-react-router"
import history from "utils/history"

export const router = connectRouter(history)

export function loader(state = false, action: any) {
	if (action.type === TYPES.SET_LOADER) {
		return action.value
	}

	return state
}

export function title(state = "", action: any) {
	if (action.type === TYPES.SET_TITLE) {
		return action.value
	}

	return state
}

export function user(state = null, action: any) {
	if (action.type === TYPES.SET_USER) {
		return action.value
	} else if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function token(state = "", action: any) {
	if (action.type === TYPES.SET_TOKEN) {
		return action.value
	} else if (action.type === TYPES.SET_LOGOUT) {
		return ""
	}

	return state
}

export function staffModal(state = null, action: any) {
	if (action.type === TYPES.SET_STAFF_DIALOG) {
		return action.value
	} else if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function breadcrumb(state: any = null, action: any) {
	if (action.type === TYPES.SET_BREADCRUMB) {
		return action.value
	} else if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function updateCrumb(state: any = null, action: any) {
	if (action.type === TYPES.SET_UPDATER) {
		return { updateCrumb: action.dispatch }
	}

	if (action.type === TYPES.UPDATE_CRUMB) {
		if (state?.updateCrumb) {
			state?.updateCrumb()
		}
	}

	return state
}

export function logsFilters(state = null, action: any) {
	if (action.type === TYPES.SET_LOGS_FILTERS) {
		return action.value
	}

	return state
}

export function language(state = null, action: any) {
	if (action.type === TYPES.SET_LANGUAGE) {
		return action.value
	}

	return state
}

export function orders(state = null, action: any) {
	if (action.type === TYPES.SET_ORDERS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function temporaryOrders(state = null, action: any) {
	if (action.type === TYPES.SET_TEMPORARY_ORDERS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function ordersToAggregate(state = null, action: any) {
	if (action.type === TYPES.SET_ORDERS_TO_AGGREGATE) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function orderFilters(state = null, action: any) {
	if (action.type === TYPES.SET_ORDER_FILTERS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function filters(state = null, action: any) {
	if (action.type === TYPES.SET_FILTERS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function orderTab(state = null, action: any) {
	if (action.type === TYPES.SET_ORDERS_TAB) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function pageSize(state = null, action: any) {
	if (action.type === TYPES.SET_PAGE_SIZE) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function notificationToken(state = "", action: any) {
	if (action.type === TYPES.SET_NOTIFICATION_TOKEN) {
		return action.value
	}

	return state
}

export function operationLinksViewMode(state = "card", action: any) {
	if (action.type === TYPES.SET_OPERATION_LINKS_VIEW_MODE) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return "card"
	}

	return state
}

export function operationLinksCollapsedGroups(state = {}, action: any) {
	if (action.type === TYPES.SET_OPERATION_LINKS_COLLAPSED_GROUPS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return {}
	}

	return state
}

export function routesTableWidth(state = 70, action: any) {
	if (action.type === TYPES.SET_ROUTES_TABLE_WIDTH) {
		return action.value
	}

	return state
}

export function routesPageSize(state = null, action: any) {
	if (action.type === TYPES.SET_ROUTES_PAGE_SIZE) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function ordersTableWidth(state = 70, action: any) {
	if (action.type === TYPES.SET_ORDERS_TABLE_WIDTH) {
		return action.value
	}

	return state
}

const defaultOrderGlobalInfo = {
	totalAggregation: 0,
	totalErrors: 0,
	totalWarnings: 0,
}

export function orderGlobalInfo(state = defaultOrderGlobalInfo, action: any) {
	if (action.type === TYPES.SET_ORDER_GLOBAL_INFO) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return defaultOrderGlobalInfo
	}

	return state
}

export function ordersStatusFilter(state: string[] | null = null, action: any) {
	if (action.type === TYPES.SET_ORDERS_STATUS_FILTER) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return null
	}

	return state
}

export function sidebarOpenGroups(
	state: Record<string, boolean> = {},
	action: any
) {
	if (action.type === TYPES.SET_SIDEBAR_OPEN_GROUPS) {
		return action.value
	}

	if (action.type === TYPES.SET_LOGOUT) {
		return {}
	}

	return state
}
